import LinkifyIt, { Match } from 'linkify-it'

const linkify = new LinkifyIt()
linkify.tlds('.org', false)

export const matchDecorator = (text: string): Match[] | null => {
  return linkify.match(text)
}
